import React, { useState } from "react";
import SaleTable from "../components/salepoint/SaleTable";
import axios from "axios";
import {
  getTxBySerialNumber,
  getTxSerialNumber,
} from "../services/transactionService";
import { transformSectionsIntoUI } from "../utils/sections";
import PageHeader from "../components/receipt/Header";

function ReceiptBySerial() {
  const [serial, setSerial] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async () => {
    if (!serial) return;

    try {
      setLoading(true);
      setError("");

      const tx = await getTxBySerialNumber(serial);

      console.log(tx);

      // 🔥 map backend → SaleTable format

      const r_transformed = transformSectionsIntoUI(tx.receive);
      const g_transformed = transformSectionsIntoUI(tx.given);
      setData({
        header: {
          serialNo: tx.serialNo,
          date: new Date(tx.transactionDate).toLocaleDateString(),
          partyName: tx.customerId?.name || "",
          time: new Date(tx.transactionDate).toLocaleTimeString(),
        },
        receive: r_transformed,
        given: g_transformed,
      });

      console.log(r_transformed);
    } catch (err) {
      console.log(err);
      setError("Transaction not found");
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader />
      <div className="container mt-4">
        {/* 🔍 Search Bar */}
        <div
          className="flex justify-content-center"
          style={{ display: "flex", gap: 10, marginBottom: 20 }}
        >
          <input
            type="text"
            placeholder="Enter serial No."
            value={serial}
            onChange={(e) => setSerial(e.target.value)}
            style={{
              padding: 10,
              border: "1px solid #d4853a",
              borderRadius: 6,
              width: 250,
            }}
          />

          <button
            onClick={handleSearch}
            style={{
              background: "#d4853a",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: 6,
            }}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>

        {/* ❌ Error */}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {/* ✅ Receipt */}
        {data && (
          <SaleTable
            header={data.header}
            receive={data.receive}
            given={data.given}
            isView={true}
          />
        )}
      </div>
    </>
  );
}

export default ReceiptBySerial;
